import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaPlus, FaList, FaSignOutAlt } from 'react-icons/fa';

function Topmenuright() {
    const navigate = useNavigate();
      const handleLogout = () => {
        try {
            localStorage.removeItem('user');
            alert('You have been logged out successfully!');
            // Use setTimeout to ensure navigation after alert
            setTimeout(() => {
                navigate('/login', { replace: true });
            }, 100);
        } catch (error) {
            console.error('Logout failed:', error);
            alert('An error occurred during logout. Please try again.');
        }
    };

  return (
    <nav class="navbar navbar-expand-lg">

      <div class="container">

        <button data-mdb-button-init class="navbar-toggler px-0" type="button" data-mdb-collapse-init
          data-mdb-target="#navbarExampleOnHover" aria-controls="navbarExampleOnHover" aria-expanded="false"
          aria-label="Toggle navigation">
        </button>

        <div class="collapse navbar-collapse" id="navbarExampleOnHover">

          <ul class="navbar-nav">    
             <li class="nav-item">
              <Link className='nav-link' to='/admin-news'>
                <FaPlus style={{ marginRight: 8 }} /> Add/Update News
              </Link>
            </li>

            <li class="nav-item">
              <Link className='nav-link' to='/AddResult'>
                <FaPlus style={{ marginRight: 8 }} /> Add Result
              </Link>
            </li>

            <li class="nav-item">
              <Link className='nav-link' to='/all-results'>
                <FaList style={{ marginRight: 8 }} /> View All Results List
              </Link>
            </li>

            <li class="nav-item">
              <button onClick={handleLogout} className="nav-link">
                <FaSignOutAlt style={{ marginRight: 8 }} /> Logout
              </button>
            </li>

            

          </ul>

        </div>

      </div>

    </nav>
  )

}

export default Topmenuright;
